<!-- <ul class="breadcrumb" >
    <li *ngFor="let navigationContent of breadCrumbNavigation"><a [routerLink]='navigationContent.url'>{{navigationContent.identifier}}</a></li>
</ul> -->
<div class="d-flex  pt-3 pb-3 article-breadcrumb">
    <span class="article-breadcrumb-sec">
        <span *ngFor="let navigationContent of breadCrumbNavigation;let lastItem = last"><a
            [routerLink]='navigationContent.url' title="{{changeIssue(navigationContent.identifier)}}">{{changeIssue(navigationContent.identifier)}}</a>
            <fa-icon *ngIf="!lastItem" aria-hidden="true" class="p-2" [icon]="['fas', 'angle-right']">
            </fa-icon>
        </span>
    </span>
</div>